import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

const SESSION_KEY = 'wynemaker.session'

const getDefaultState = () => ({
    inSession: false,

    current_page: 'Welcome',
    previous_page: 'Login',

    user: {},
    user_id: 0,
    profile_picture: '',
    language: 'en',
})

export const store = new Vuex.Store({
    state: getDefaultState(),

    getters:{
        inSession: state => {
            return state.inSession
        },

        currentUser: state => {
            return state.user
        },

        currentUserID: state => {
            return state.user_id
        },

        profilePicture: state => {
            return state.profile_picture
        },

        currentLanguage: state => {
            return state.language
        },

        currentPage: state => {
            return state.current_page
        },

        previousPage: state => {
            return state.previous_page
        }
    },

    mutations:{
        resetStore: state => {
            Object.assign(state, getDefaultState())
        },

        login:state=>{
            state.inSession = true;
        },

        logout:state=>{
            state.inSession = false;
        },

        setUser:(state,currentUser)=>{
            state.user = currentUser;
        },

        setUserID:(state,userID)=>{
            state.user_id = userID;
        },

        setProfilePicture:(state,profile_picture)=>{
            state.profile_picture = profile_picture;
        },

        setLanguage:(state,language)=>{
            state.language = language
        },

        setPage:(state,page)=>{
            state.previous_page = state.current_page;
            state.current_page = page;
        },
    }
})


/*
 * Persist ONLY the user ID.
 *
 * Never persist the complete user because it may contain
 * large base64 encoded images.
 */
store.subscribe((mutation, state) => {

    /*
     * LOGOUT OR RESET
     */
    if (
        mutation.type === 'logout' ||
        mutation.type === 'resetStore'
    ) {
        sessionStorage.removeItem(SESSION_KEY)
        return
    }

    /*
     * STORE ONLY A VALID LOGGED-IN USER ID
     */
    if (
        state.inSession === true &&
        state.user_id &&
        state.user_id !== 0
    ) {

        try {

            sessionStorage.setItem(
                SESSION_KEY,
                JSON.stringify({
                    user_id: state.user_id
                })
            )

        } catch (error) {

            console.log("store.subscribe: Could not save session - ", error)

        }
    }
})